import { IGenericObject } from '../typings/common-types';

export const isEmptyObject = (object: IGenericObject) => !Object.keys(object).length;
export const isValidObject = (object: IGenericObject) => object && !isEmptyObject(object);
export const iif: any = (condition: any, valueFirst: any, valueSecond: any) => (condition ? valueFirst : valueSecond);
